// extracted by mini-css-extract-plugin
export default {"title":"styles_title__f+xeW","permissions":"styles_permissions__uQ9dQ","buttons":"styles_buttons__BALz6"};